import { render, staticRenderFns } from "./MemberNavigation.vue?vue&type=template&id=20af714b&scoped=true"
import script from "./MemberNavigation.vue?vue&type=script&lang=js"
export * from "./MemberNavigation.vue?vue&type=script&lang=js"
import style0 from "./MemberNavigation.vue?vue&type=style&index=0&id=20af714b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af714b",
  null
  
)

export default component.exports